export default "__VITE_ASSET__IDM59szY__"